// https://vuex.vuejs.org/en/mutations.html

export default {
  setUser(state, user) {
    localStorage.setItem("user", user);
  },
  setBaseUrl(state, v) {
    state.baseUrl = v;
    localStorage.setItem("baseUrl", state.baseUrl);
  },
  confirm(state, confirmation) {
    confirmation.id = _.uniqueId();
    confirmation.width = confirmation.width || 350;
    confirmation.onConfirm = confirmation.onConfirm || null;
    confirmation.form = confirmation.form || null;
    confirmation.onCancel = confirmation.onCancel || null;
    confirmation.confirmBtnText = confirmation.confirmBtnText || "Yes";
    confirmation.cancelBtnText = confirmation.cancelBtnText || "Cancel";

    return state.app.confirmLine.push(confirmation);
  },
  push(state, ml) {
    ml.id = _.uniqueId();
    return state.app.messageLine.push({
      id: ml.id,
      text: ml.msg,
      color: ml.color,
      isVisible: true,
      createdAt: new Date().getTime(),
      timeout: 3000
    });
  },
  shift(state) {
    return state.app.messageLine.shift();
  }
};
